import AppIcons, { type ServiceTile } from "@/components/ui/boxy-app-icons";

interface BoxyAppIconsDemoProps {
  tiles: readonly ServiceTile[];
}

export default function BoxyAppIconsDemo({ tiles }: BoxyAppIconsDemoProps) {
  return <AppIcons tiles={tiles} />;
}
